import { lazy } from 'react'

/**
 * Módulo: Tutoriales
 * Capacitación interna — videos cortos grabados desde el navegador
 * mostrando cómo se hace algo en la plataforma.
 *
 * Grabador in-app (pantalla + mic + cámara opcional como burbuja overlay
 * tipo Loom). Archivos en Firebase Storage. Compartibles por 3 canales
 * (notif in-app, mensajería interna Milbrands, email).
 *
 * Diseñado en sesión 26-may-2026 (ver ESTADO_ACTUAL.md). Implementado por
 * bloques: este config es parte del Bloque 1 (esqueleto + permisos).
 *
 * Ver: ESTADO_ACTUAL.md sesión 26-may.
 */
export default {
  id: 'tutoriales',
  nombre: 'Tutoriales',
  descripcion: 'Capacitación interna — videos grabados in-app (pantalla + mic + cámara opcional)',
  icono: 'video',
  tipo: 'core',
  version: '0.1.0',
  // Tipos de usuario que VEN el módulo en el sidebar. El gating fino lo hace
  // el permiso `tutoriales.ver` desde la matriz /permisos.

  routes: [
    { path: 'tutoriales', component: lazy(() => import('./pages/TutorialesPage')) },
    { path: 'tutoriales/:tutorialId', component: lazy(() => import('./pages/TutorialDetailPage')) },
  ],

  // "Tutoriales" se mudó al grupo GESTIÓN (gestion/config.js) el 7-jul — la
  // ruta /tutoriales sigue acá (routes), solo se movió el ítem del menú. Sin
  // ítems propios, el grupo TUTORIALES ya no aparece en el sidebar.
  menuItems: [],

  features: [
    'tutoriales',
  ],

  // permisoModulos (#58): se deriva del rol.
  permisoModulos: ['tutoriales'],

}
